module.exports = __webpack_public_path__ + "img/icon-home.2e0e0e62.svg";